import { modules, useFeature } from "byzantine";

export default function useIsMxIAVEnabled() {
  const { featureEquals } = useFeature();
  // Note that this DOES NOT match the logic in the backend syncing, we only check the
  // `instant_account_verification` instead of the `trends`.
  const isMxIAVEnabled = featureEquals("instant_account_verification", "mx");
  // Instant add and reconnect can add new external accounts, so they should also
  // respect the same create permission as the other add-account entry points.
  const hasAddExternalAccountPermission =
    modules.externalAccounts.useAddExternalAccountPermission();

  return isMxIAVEnabled && hasAddExternalAccountPermission;
}
